import { render, staticRenderFns } from "./BookKeepingReports.vue?vue&type=template&id=0094bb5f&scoped=true"
import script from "./BookKeepingReports.vue?vue&type=script&lang=js"
export * from "./BookKeepingReports.vue?vue&type=script&lang=js"
import style0 from "./BookKeepingReports.vue?vue&type=style&index=0&id=0094bb5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0094bb5f",
  null
  
)

export default component.exports